import http from '@/http'
const URL = '/admin/flight-blocks'

export const list = async (params) => {
  return http.get(URL, { params: params })
}

export const show = async (id) => {
  return http.get(URL + `/${id}`)
}

export const save = (payload) => {
  return http.post(URL, payload)
}

export const update = (payload) => {
  return http.put(URL + `/${payload.id}`, payload)
}

export const toggle = (id) => {
  return http.patch(URL + `/${id}/toggle`)
}

export const duplicate = (id) => {
  return http.post(URL + `/${id}/duplicate`)
}

export const remove = (id) => {
  return http.delete(URL + `/${id}`)
}

export const applyToParticipant = (blockId, participantId) => {
  return http.post(URL + `/${blockId}/apply/${participantId}`)
}

export default {
  list,
  show,
  save,
  update,
  toggle,
  duplicate,
  remove,
  applyToParticipant
}
